export class Pagination {
  totalPages: number;
  totalElements: number;
  hasPrevious: boolean;
  hasNext: boolean;
  hasContent: boolean;
  numberOfElement: number;
  size: number;
}
